import { Component, Inject, PipeTransform } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { GeneralService } from '../general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-cert',
  templateUrl: './view-cert.component.html',
  styleUrls: ['./view-cert.component.css','../travel-modal/travel-modal.component.css']
})
export class ViewCertComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewCertComponent>,
    private sanitizer: DomSanitizer,
    private s: GeneralService,
    private toaster: ToastrService
  ) {}
  cleanURL(oldURL: string): SafeUrl {
    console.log(oldURL)
    return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }
  mdd(){
    console.log(this.data.url)
    window.open(this.data.url)
  }
}
// @Pipe({
//   name: "safeUrl",
//   pure: true
// })
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
